import styled from "styled-components";

export const TogglePlayerStyles = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
`;